module.exports = angular.module('trigger-panel-alert', [])
    .directive('panelAlert', function () {
        return {
            restrict: 'E',
            scope: {
                isSuccess: '=',
                message: '@'
            },
            templateUrl: 'app/views/triggerPanel/panel-alert.tpl.html',
            controller: ['$rootScope', '$scope', function ($rootScope, $scope) {
                $scope.translate = $rootScope.translate;
            }]
        };
    });



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/triggerPanel/panel-alert.js